export default {
  activeBorderColor: Styles.color.primary,
  backgroundColor: Styles.color.white,
  birthdayLabelColor: '',
  inactiveBorderColor: Styles.color.grey.four,
  placeholderColor: '',
};
